import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";
import {IBoosterBigDataType} from "../types/IBoosterBigDataType";
import {IBoosterCategory} from "../types/IBoosterCategory";
import {IBoosterOfferStatsType} from "../types/IBoosterOfferStatsType";
import {gtmBoosterCategoryMap} from "./gtm_booster_category_map";
import {getBoosterCategoryTypeLabel} from "./gtm_booster_category_type_map";

const trackBoosterView = (label: string, category: IBoosterCategory, boosterType: IBoosterOfferStatsType | IBoosterBigDataType | IBoosterCategory) => {
    const eventData = {
        event: "booster",
        event_action: "view",
        event_label: label,
        event_category: gtmBoosterCategoryMap[category] || "na",
        event_category2: getBoosterCategoryTypeLabel(category, boosterType) || "na"
    };

    hitGoogleTagManager(eventData);
};

const trackBoosterClick = (label: string, category: IBoosterCategory, boosterType: IBoosterOfferStatsType | IBoosterBigDataType | IBoosterCategory) => {
    const eventData = {
        event: "booster",
        event_action: "click",
        event_label: label,
        event_category: gtmBoosterCategoryMap[category] || "na",
        event_category2: getBoosterCategoryTypeLabel(category, boosterType) || "na"
    };

    hitGoogleTagManager(eventData);
};

export const boosterTracking = {
    gtm: {
        trackBoosterView,
        trackBoosterClick
    }
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";
import {IBoosterBigDataType} from "../types/IBoosterBigDataType";
import {IBoosterCategory} from "../types/IBoosterCategory";
import {IBoosterOfferStatsType} from "../types/IBoosterOfferStatsType";
import {gtmBoosterCategoryMap} from "./gtm_booster_category_map";
import {getBoosterCategoryTypeLabel} from "./gtm_booster_category_type_map";

const trackBoosterView = (label: string, category: IBoosterCategory, boosterType: IBoosterOfferStatsType | IBoosterBigDataType | IBoosterCategory) => {
    const eventData = {
        event: "booster",
        event_action: "view",
        event_label: label,
        event_category: gtmBoosterCategoryMap[category] || "na",
        event_category2: getBoosterCategoryTypeLabel(category, boosterType) || "na"
    };

    hitGoogleTagManager(eventData);
};

const trackBoosterClick = (label: string, category: IBoosterCategory, boosterType: IBoosterOfferStatsType | IBoosterBigDataType | IBoosterCategory) => {
    const eventData = {
        event: "booster",
        event_action: "click",
        event_label: label,
        event_category: gtmBoosterCategoryMap[category] || "na",
        event_category2: getBoosterCategoryTypeLabel(category, boosterType) || "na"
    };

    hitGoogleTagManager(eventData);
};

export const boosterTracking = {
    gtm: {
        trackBoosterView,
        trackBoosterClick
    }
};
